import React, { FC, useCallback } from "react";
import { Menu } from "@evergis/ui";

import { useToggle } from "../../../../hooks/useToggle";
import { RefContainer } from "../../styled";
import { PopupWithCustomBlank } from "../../../Classification/styled";
import { StyledIconButton } from "./styled";
import { Tooltip } from "../Classifiers/styled";

import { ComplexButtonProps, MenuButtonProps } from "./types";

const MenuButton: FC<MenuButtonProps> = ({ innerRef, children, options, selectOption, icon }) => {
  const [menuOpened, toggleMenu] = useToggle();

  const onSelect = useCallback(
    option => {
      selectOption(option);
      toggleMenu();
    },
    [selectOption, toggleMenu],
  );

  return (
    <PopupWithCustomBlank
      onRequestClose={toggleMenu}
      isVisible={menuOpened}
      placement="bottom-start"
      anchor={popupRef => (
        <StyledIconButton kind={icon} innerRef={innerRef} onClick={toggleMenu} fixedWidth={!children}>
          <RefContainer ref={popupRef} />
          {children}
        </StyledIconButton>
      )}
    >
      <Menu options={options} selectOption={onSelect} />
    </PopupWithCustomBlank>
  );
};

export const ComplexButton: FC<ComplexButtonProps> = ({ tooltip, children, ...props }) => {
  return tooltip ? (
    <Tooltip content={tooltip}>{tooltipRef => <MenuButton {...props} innerRef={tooltipRef} />}</Tooltip>
  ) : (
    <MenuButton {...props}>{children}</MenuButton>
  );
};
